import { Ng2StateDeclaration } from '@uirouter/angular';
import {
    paginationUrlQueryParamsValidator,
} from '@client/app/shared-modules/state/state-validators/pagination-url-query-params-validator';
import {
    AdminApiTokensComponent,
} from '@client/app/feature-modules/admin/modules/admin-api-tokens/components/admin-api-tokens/admin-api-tokens.component';
import {
    paginationUrlQueryParamsDeclarations,
} from '@client/app/shared-modules/state/state-params-declarations/pagination-params-declarations';
import { Injectable } from '@angular/core';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

@Injectable({ providedIn: 'root' })
export class ApiUsersAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (this.activeFeatureService.isFeatureActive('api_users')) {
            return true;
        }
        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.admin.dashboard', params) as unknown as Promise<void>;
        });
    }
}
export const AdminApiTokensStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin.api-users',
        url: '/api-users?page_size&page',
        params: {
            ...paginationUrlQueryParamsDeclarations(),
        },
        resolve: [
            {
                token: 'apiUsersAccess',
                deps: [ApiUsersAccessGuard, Transition],
                resolveFn: (guard: ApiUsersAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
        redirectTo: paginationUrlQueryParamsValidator('base.customer.admin.api-users'),
        component: AdminApiTokensComponent,
        data: {
            title: 'Acquia Web Governance - API Tokens',
            /** Shell-facing path for CC breadcrumb/menu sync (see event-bus-bridge.init.ts) */
            shellPath: '/admin/api-tokens',
        },
    },
];
